import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {SelectBinding} from '../../../../domain/selectBinding';
import {Area} from '../../../../domain/areas';
import {SubCategoria} from '../../../../domain/subCategorias';
import {Sede} from '../../../../domain/sedes';
import {Categoria} from '../../../../domain/categorias';
import {FormService} from '../../../../services/formServices';
import {ToastrService} from 'ngx-toastr';
import {FormGroup} from '@angular/forms';

@Component({
  selector: 'app-select-binding-modificacion',
    templateUrl: './select-binding.component.html',
  styleUrls: ['../../select-binding/select-binding.component.scss']
})
export class SelectBindingModifComponent implements OnInit {
    @Input('type') type: string;
    @Input('combos')combos: any;
    @Input('id')id:any;
    @Input('disable')_disable:any;
    categoria: any;
    subcategoria: any;
    selectedValue1: any;
    selectedValue2: any;
    sistema: any;
    disable: boolean;
    @Output('selected') selected = new EventEmitter<any>();
    constructor(private formService: FormService, private toastr: ToastrService) { }
    ngOnInit() {
        this.disable = this._disable;
      this.selectedValue1 = this.combos != undefined ? this.combos.categoria : 1;
      this.selectedValue2 = this.combos != undefined ? this.combos.subcategoria : 1;
      this.sistema = this.combos != undefined ? this.combos.sistema : 1;
        if (this.type === 'zone') {
            this.categoria = new Area();
            this.subcategoria = new Sede();
            this.formService.getDataAreas().subscribe(list => this.categoria.list = list);
            this.formService.getDataSedes(this.selectedValue1).subscribe(list => this.subcategoria.list = list);
        } else if (this.type === 'request') {
            this.categoria = new Categoria();
            this.subcategoria = new SubCategoria();
            this.formService.getDataCategoria().subscribe(list => this.categoria.list = list);
            this.formService.getDataSubCategoria(this.selectedValue1).subscribe(list => this.subcategoria.list = list);
        }
    }
    onChange() {
        if (this.type === 'zone') {
            this.formService.getDataSedes(this.selectedValue1).subscribe(list => this.subcategoria.list = list);
        } else if (this.type === 'request') {
            this.formService.getDataSubCategoria(this.selectedValue1).subscribe(list => this.subcategoria.list = list);
        }
        this.sistema = 0;
        this.selectedValue2 = 0;
        this.enviarCambios();
    }
    setSubcat() {
        if(!this.tieneSistemas()){
            this.sistema = 0;
            this.enviarCambios();
        } else {
            this.enviarCambios();
        }
    }

    setSistema(id:number){
        this.sistema = id;
        this.enviarCambios();
    }

        enviarCambios(){
            const data = {categoria: this.selectedValue1, subcategoria: this.selectedValue2, sistema: this.sistema};
            this.selected.emit(data);
        }

        tieneSistemas(){
            return this.selectedValue2 != 15 && this.selectedValue2 != 35 && this.selectedValue2 != null && this.selectedValue1 == 2;
        }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/selects/modificar/select-binding/select-binding.component.ts